import { VNodeDirective, VNode} from 'vue';

export default {
	bind(el: HTMLElement, binding: VNodeDirective, vnode: VNode) {
		const disablePopupBehavior = binding.value != null && binding.value.disablePopupBehavior === true;

		const autocomplete: any = vnode.componentInstance;
		const popover: any = autocomplete.$refs.popover;
		const parentReposition = popover.reposition;

		popover.reposition = (event: any, animate: any) => {
			parentReposition.call(popover, event, animate);

			const bodyRect = document.body.getBoundingClientRect();
			const elemRect = autocomplete.$parent.$el.getBoundingClientRect();

			let offset = elemRect.bottom - bodyRect.top;

			if (popover.$el.classList.contains('animate-popup-up')) {
				if (disablePopupBehavior) {
					popover.$el.classList.remove('animate-popup-up');
					popover.$el.classList.add('animate-popup-down');

					// listenOpts.passive value is browser-dependent; remove the scroll event hook regardless of its value
					popover.scrollTarget.removeEventListener('scroll', popover.__updatePosition, false);
					popover.scrollTarget.removeEventListener('scroll', popover.__updatePosition, true);
				} else {
					// render offscreen to determine height for up-animations
					const clone = popover.$el.cloneNode(true);

					clone.classList.remove('animate-popup-up');
					clone.classList.remove('animate-popup-down');
					clone.style.visibility = 'hidden';

					document.body.parentNode!.insertBefore(clone, document.body.nextSibling);
					offset = offset - (elemRect.height + clone.getBoundingClientRect().height);
					document.body.parentNode!.removeChild(clone);
				}
			}

			popover.$el.style.position = 'absolute';
			popover.$el.style.top = offset + 'px';
		};
	},
};
